module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-avatar', {
    attrs: {
      "shape": "square",
      "size": _vm.size
    }
  }, [_c('div', {
    staticClass: "wai-view",
    class: _vm.mod
  }, [_c('div', {
    staticClass: "name-text",
    style: (_vm.textStyle),
    domProps: {
      "innerHTML": _vm._s(_vm.nametext)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8e6b8f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/avatar-view.vue
// module id = 906
// module chunks = 1